<div class="section">
  <header>
    <h1>Page Not Found</h1>
  </header>

  <main>
    <button routerLink="/landing">Landing</button>
  </main>
</div>
